
export class JustificativaExtracao {
  constructor(justificativa: string) {
    this.justificativaExtracao = justificativa;
  }
  justificativaExtracao?: string;
}

export class JustificativaExtracaoRelatorio {
  justificativaExtracao!: string;
}
